(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ap-bundles"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const FORM = 'form[data-type="add-to-cart-form"]';
    const WRAP = '.ap-bundle';

    document.addEventListener('submit', (e) => {
      const form = e.target.closest && e.target.closest(FORM);
      if (!form) return;
      const wrap = form.closest(WRAP);
      if (wrap) wrap.classList.add('is-adding');
    }, true);

    const clear = () => {
      document.querySelectorAll(WRAP + '.is-adding').forEach((el) => el.classList.remove('is-adding'));
    };
    document.addEventListener('cart:update', clear);
    document.addEventListener('cart:error', clear);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-pack-selector"] && !Shopify.designMode) return;
  try {
    
  /* TODO: Appstle integration — this JS updates the quantity input and displayed prices.
     Appstle Bundles applies the actual tiered discount at checkout.
     Verify this works correctly after Appstle Bundles is configured. */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ap-packs').forEach(function (section) {
      var basePrice = parseInt(section.dataset.productPrice, 10);
      var cards = section.querySelectorAll('.ap-pack');
      var qtyInput = document.querySelector('input[name="quantity"], [data-quantity-input]');

      function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      function selectPack(card) {
        cards.forEach(function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-pressed', 'false');
        });
        card.classList.add('is-selected');
        card.setAttribute('aria-pressed', 'true');

        var qty = parseInt(card.dataset.quantity, 10);
        var discount = parseInt(card.dataset.discount, 10) || 0;
        var unitPrice = Math.round(basePrice * (1 - discount / 100));
        var totalPrice = unitPrice * qty;

        card.querySelector('[data-pack-total]').textContent = formatMoney(totalPrice);
        card.querySelector('[data-pack-unit]').textContent = formatMoney(unitPrice) + ' each';

        if (qtyInput) {
          qtyInput.value = qty;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        var atcBtn = document.querySelector('[name="add"], .product-form__submit, [data-add-to-cart]');
        if (atcBtn) {
          var btnText = atcBtn.querySelector('.button__text, span') || atcBtn;
          btnText.textContent = 'Add to cart \u00B7 ' + formatMoney(totalPrice);
        }
      }

      cards.forEach(function (card) {
        var qty = parseInt(card.dataset.quantity, 10);
        var discount = parseInt(card.dataset.discount, 10) || 0;
        var unitPrice = Math.round(basePrice * (1 - discount / 100));
        var totalPrice = unitPrice * qty;
        card.querySelector('[data-pack-total]').textContent = formatMoney(totalPrice);
        card.querySelector('[data-pack-unit]').textContent = formatMoney(unitPrice) + ' each';

        card.addEventListener('click', function () { selectPack(card); });
      });

      var defaultCard = section.querySelector('.ap-pack.is-selected');
      if (defaultCard) selectPack(defaultCard);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
